
import { Habit } from "@/context/SupabaseHabitContext"; // Changed from HabitContext to SupabaseHabitContext
import HabitGrid from "./habit-grid/HabitGrid";

interface MainHabitGridProps {
  habit: Habit;
  initialMonths?: number;
  externalEditMode?: boolean;
  onToggleEditMode?: () => void;
}

// This is a simple wrapper to maintain backward compatibility
export default function MainHabitGrid({ 
  habit,
  initialMonths = 6,
  externalEditMode,
  onToggleEditMode,
}: MainHabitGridProps) {
  return (
    <HabitGrid 
      habit={habit}
      initialMonths={initialMonths}
      externalEditMode={externalEditMode}
      onToggleEditMode={onToggleEditMode}
    />
  );
}
